import React from 'react';
import { Box, Group, Loader, Stack, Text } from '@mantine/core';

export interface EntityDetailPhotoProps {
    shouldShowPhoto: boolean;
    fullEntity: any;
    entity: any;
    photoData: string | null;
    photoLoading: boolean;
    photoExpanded: boolean;
    setPhotoExpanded: (expanded: boolean) => void;
}

export const EntityDetailPhoto: React.FC<EntityDetailPhotoProps> = ({
    shouldShowPhoto,
    fullEntity,
    entity,
    photoData,
    photoLoading,
    photoExpanded,
    setPhotoExpanded,
}) => {
    if (!shouldShowPhoto || !fullEntity) {
        return null;
    }

    return (
        <Group justify="center" mb="xs">
            <Stack align="center" w="100%">
                <Text size="sm" c="dimmed" mb="xs">
                    Photo
                </Text>
                {photoLoading ? (
                    <Loader size={80} />
                ) : photoData ? (
                    <Group justify="center" align="center" w="100%" style={{ transition: 'all 0.3s ease-in-out' }}>
                        <img
                            src={`data:image/jpeg;base64,${photoData}`}
                            alt="User photo"
                            onClick={() => setPhotoExpanded(!photoExpanded)}
                            style={{
                                width: photoExpanded ? 'auto' : 80,
                                height: photoExpanded ? 'auto' : 80,
                                maxWidth: photoExpanded ? '100%' : '80px',
                                maxHeight: photoExpanded ? '70vh' : '80px',
                                borderRadius: photoExpanded ? '8px' : '50%',
                                objectFit: photoExpanded ? 'contain' : 'cover',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease-in-out',
                                boxShadow: photoExpanded ? '0 4px 20px rgba(0,0,0,0.3)' : 'none',
                            }}
                            onMouseEnter={(e) => {
                                if (!photoExpanded) {
                                    e.currentTarget.style.transform = 'scale(1.05)';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (!photoExpanded) {
                                    e.currentTarget.style.transform = 'scale(1)';
                                }
                            }}
                        />
                    </Group>
                ) : (
                    <Group
                        w={80}
                        h={80}
                        justify="center"
                        align="center"
                        bg="var(--mantine-color-default-hover)"
                        style={{ borderRadius: '50%' }}
                    >
                        <Text
                            size="xs"
                            c="dimmed"
                            ta="center"
                            maw="100%"
                            style={{ lineHeight: 1.2, wordWrap: 'break-word' }}
                        >
                            {entity.Photo ? 'No Photo' : 'No Photo Available'}
                        </Text>
                    </Group>
                )}
            </Stack>
        </Group>
    );
};
